<style lang="stylus">
    .templatemodal-box
        width 698px
        height 540px
        padding-bottom 0
        .dialog-title
            height 40px
            padding 0 8px 0 24px
            .title-text
                font-weight 800
                line-height 40px
            .title-close
                width 24px
                height 24px
                right 8px
                top 8px
        .dialog-slot
            height calc(100% - 40px)
        .templatemodal-scroll
            width 100%
            height 100%
            padding 16px 24px
            overflow-x hidden
            overflow-y auto
            display flex
            flex-wrap wrap
            column-gap 24px
            row-gap 24px
            user-select none
            &::-webkit-scrollbar
                width 8px
                pointer-events none
                background none
            &::-webkit-scrollbar-thumb
                background #D2D3D6
                border-radius 4px
                border 1px solid #fff
            &::-webkit-scrollbar-track
                background #fff
            &::-webkit-scrollbar-track-piece
                background none
            &::-webkit-scrollbar-corner
                background none
            .template-block
                display flex
                justify-content center
                position relative
                width 198px
                height 172px
                border-radius 8px
                border 1px solid rgba(0, 0, 0, 0.08)
                background #FFF
                overflow hidden
                &:hover
                    .template-mask
                        display flex
                img
                    width 182px
                    height 116px
                    object-fit contain
                    margin 8px 0
                    padding 0
                    border-radius 0
                .template-titlebox
                    position absolute
                    left 0
                    bottom 0
                    display flex
                    align-items center
                    width 100%
                    height 40px
                    padding 0 6px
                    border-top 1px solid rgba(0,0,0,0.08)
                    p
                        color #222
                        font-size 12px
                        line-height 16px
                .template-mask
                    display none
                    align-items center
                    justify-content center
                    position absolute
                    left 0
                    right 0
                    top 0
                    bottom 0
                    background rgba(0,0,0,0.4)
                    p
                        blueBtn()
                        padding 0 12px
                        height 28px
                        border-radius 4px
                        cursor pointer
            .templatemodal-emptyCloud
                display flex
                flex-direction column
                align-items center
                justify-content center
                position absolute
                top 50%
                left 50%
                transform translate(-50%, -50%)
                font-size 12px
                img
                    display block
                    margin-bottom 8px
                p
                    color #222
                    font-size 12px
                    line-height 16px
                .click-text
                    color #017fff
                    cursor pointer
                    text-decoration underline
</style>

<template>
    <Dialog :title="$t('customTemplate')" :mask="true" :extra="true" class="templatemodal-box" @close="close">
        <div class="templatemodal-scroll" v-click-outside="closeContext" @scroll="closeContext" @click="closeContext" @contextmenu.stop.prevent>
            <div class="template-block" v-for="(item, index) in customTList" @contextmenu="showCustomTContext($event, index)">
                <img :src="item.img_url" alt="" />
                <div class="template-titlebox">
                    <p>{{ item.name }}</p>
                </div>
                <div class="template-mask">
                    <p @click="useCustomTemplate(item)">{{ $t("useNow") }}</p>
                </div>
            </div>

            <div class="templatemodal-emptyCloud" v-show="emptyStatus">
                <img src="@/home/assets/img/null-icon/template-null.svg" alt="" />
                <p>
                    {{ $t("customNoData") }}
                    <span class="click-text" @click="toCloud" v-if="internal && !isWorkwx">{{ $t("customTocloud") }}</span>
                </p>
            </div>
            <div ref="scrollblock"></div>
        </div>
        <RightMenu
            v-if="menuContext.show && menuContext.type == 'customTemplate'"
            :style="{ left: `${menuContext.left}px`, top: `${menuContext.top}px` }"
            :menuList="[{ label: $t('deleteCustomT') }]"
            @handleClicks="deleteCustomTemplate()"
        />
    </Dialog>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import Dialog from "@/home/parts/Dialog.vue";
    import RightMenu from "../../RightMenu.vue";
    import { openNewTab } from "@/public/utils/tool";
    @Component({
        components: {
            Dialog,
            RightMenu,
        },
    })
    export default class TemplateModal extends Vue {
        close() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        customLoaded = false;
        customTPageInfo = {
            total: 0,
            count: 20,
            offset: 0,
            currentPage: 1,
        };
        customTList = [];
        customDelIndex = -1;
        useCustomTFlag = false;
        get emptyStatus() {
            return this.customLoaded && this.activeList.length == 0;
        }
        get showCustomPage() {
            return this.customTList.length > 0 && this.customTPageInfo.total > this.customTPageInfo.count;
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        initCustomData() {
            if (!this.$validateLogin()) return;
            this.customLoaded = false;
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                offset: (this.customTPageInfo.currentPage - 1) * this.customTPageInfo.count,
                count: this.customTPageInfo.count,
            };
            this.$edApi.getCustomTemplateList(user).then((e) => {
                this.customLoaded = true;
                this.customTList = e.data || [];
                this.customTPageInfo.total = e.msg - 0;
                console.log(this.customTList);
                this.addScroller();
            });
        }
        changeCustomTemplatePage(page) {
            if (!this.$validateLogin()) return;
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                offset: (page - 1) * this.customTPageInfo.count,
                count: this.customTPageInfo.count,
            };
            this.$edApi.getCustomTemplateList(user).then((e) => {
                this.customTPageInfo.currentPage = page;
                this.customTList = this.customTList.concat(e.data);
                this.customTPageInfo.total = e.msg - 0;
                this.scrollAdding = false;
            });
        }

        initData() {
            this.initCustomData();
        }
        nextPage(page) {
            this.changeCustomTemplatePage(page);
        }
        resetPageInfo() {
            this.customTPageInfo = {
                total: 0,
                count: 20,
                offset: 0,
                currentPage: 1,
            };
        }
        get activeList() {
            return this.customTList;
        }
        get activePageInfo() {
            return this.customTPageInfo;
        }
        menuContext = {
            left: 0,
            top: 0,
            type: "",
            show: false,
        };
        showCustomTContext(e, index) {
            e.preventDefault();
            this.menuContext.type = "customTemplate";
            this.menuContext.show = true;
            this.menuContext.left = e.pageX;
            this.menuContext.top = e.pageY;
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.menuContext.top -= 44;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.menuContext.left -= 117;
            }
            this.customDelIndex = index;
        }
        closeContext() {
            this.menuContext.show = false;
        }
        useCustomTemplate(item) {
            if (!this.$validateLogin() || this.useCustomTFlag) return;
            let ts: any = this;
            this.useCustomTFlag = true;
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                template_id: item.id,
                platform: this.$store.state.publicStore.runPlatform,
                tpl_file_key: item.tpl_file_key,
            };
            let newTab: any;
            let newTabCallback;
            let cancelOpen;
            if (!this.openInTabs) {
                // newTab = window.open(`${window.location.origin}${(<any>this.$router).options.base}app.html`, "");
                let task = openNewTab(`${window.location.origin}${(<any>this.$router).options.base}app.html`, this.$edMessage.destroy);
                newTabCallback = task.openTab;
                cancelOpen = task.cancelOpen;
                this.$edMessage.info(this.$tc("newPageCreateFile"), 0);
            }
            let limitCallback = (type = "") => {
                newTab && newTab.close();
                cancelOpen && cancelOpen();
                this.$edMessage.destroy();
                if (type == "showLimitModal") {
                    this.$bus.$on("limitModalContinue", () => {
                        console.log("on event");
                        this.$bus.$off("limitModalContinue");
                        this.useCustomTemplate(item);
                    });
                    this.$store.commit("setState", {
                        type: "showLimitFileModal",
                        data: true,
                    });
                } else if (type == "showLimitCloudSpaceVIP") {
                    if (this.fuser) {
                        this.$bus.$emit("showCloudSpaceVipTips");
                    } else {
                        this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
                    }
                } else if (type == "showLimitCloudSpace") {
                    this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
                } else {
                    this.$store.commit("toPublicStatus", {
                        type: "showUpgrade",
                        data: "fileNum",
                    });
                }
            };
            let enterCanvasTrack = `&file_source=templateFile&template_type=personalTemplate&diagram_type=others`;
            let trackSuffix = "";
            trackSuffix += enterCanvasTrack;
            this.$openFile({
                params: user,
                fileType: "customTemplate",
                suffix: trackSuffix,
                checkLimit: true,
                limitRange: this.$store.state.publicStore.runPlatform,
                limitCallback: limitCallback,
                vip: this.vip,
                isFullCouldSpace: this.isFullCouldSpace,
            })
                .then((obj) => {
                    this.sensors.track("generateCloudFile", {
                        Catalogues: "openFileProcess",
                        file_source: "templateFile",
                    });
                    if (this.openInTabs) {
                        location.href = obj.url;
                    } else {
                        this.$edMessage.destroy();
                        newTab = newTabCallback(obj.url);
                    }
                    this.useCustomTFlag = false;

                    // add open record
                    let key = obj.obj;
                    let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                    if (!openTabs.includes(key)) {
                        openTabs.push(key);
                    }
                    this.$store.commit("addWin", newTab);
                    localStorage.setItem("openTabs", JSON.stringify(openTabs));
                })
                .catch(() => {
                    this.useCustomTFlag = false;
                });
        }
        deleteCustomTemplate() {
            if (!this.$validateLogin()) return;
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                template_ids: [this.activeList[this.customDelIndex].id],
            };
            if (this.isPrivate) {
                Object.assign(user, {
                    tpl_file_keys: [this.activeList[this.customDelIndex].tpl_file_key],
                });
            }
            this.$edApi.deleteCustomTemplate(user).then((e) => {
                this.customDelIndex = -1;
                this.closeContext();
                this.resetPageInfo();
                this.initData();
            });
        }
        scrollAdding = false;
        observe = null;
        addScroller() {
            if (this.observe) {
                this.observe.unobserve(this.$refs.scrollblock);
                this.observe = null;
            }
            let dom = this.$refs.scrollblock;
            if (dom) {
                this.observe = new (window as any).IntersectionObserver((e) => {
                    console.log(e);
                    if (e[0] && e[0].isIntersecting && !this.scrollAdding && this.activePageInfo.total >= this.activeList.length) {
                        this.scrollAdding = true;
                        this.nextPage(this.activePageInfo.currentPage + 1);
                    }
                });
                this.observe.observe(dom);
            }
        }

        toCloud() {
            let url = this.isPrivate ? `${this.urls.helpcenterUrl}/help/web/guide/89/311` : "https://www.edrawmax.cn/helpcenter/web/guide/89/311";
            window.open(url);
        }

        mounted() {
            this.initCustomData();
        }

        created() {}
        beforeDestroy() {
            this.observe?.unobserve(this.$refs.scrollblock);
            this.observe = null;
        }
    }
</script>
<i18n>
{
    "zh": {
    "customTemplate": "个人模板",
    "customNoData": "还没有个人模板",
    "customTocloud": "了解如何创建？",
    "useNow": "立即使用",
    "deleteCustomT": "删除"
    },
    "en": {
    "customTemplate": "Personal Template",
    "customNoData": "You haven't created your personal template.",
    "customTocloud": "Learn how to create？",
    "useNow": "Use Now",
    "deleteCustomT": "Delete"
    },
    "fr": {
    "customTemplate": "Modèle personnel",
    "customNoData": "Vous n'avez pas créé votre modèle personnel. ",
    "customTocloud": "Apprenez à créer？",
    "useNow": "Utilisez ce modèle",
    "deleteCustomT": "Effacer"
    },
    "de": {
    "customTemplate": "Persönliche Vorlage",
    "customNoData": "Sie haben Ihre persönliche Vorlage noch nicht erstellt. Hier erfahren sie,",
    "customTocloud": "wie die erstellt wird？",
    "useNow": "Diese Vorlage verwenden",
    "deleteCustomT": "Löschen"
    },
    "jp": {
    "customTemplate": "個人テンプレート",
    "customNoData": "個人用のテンプレートが作成されていません。",
    "customTocloud": "作成方法はこちら",
    "useNow": "このテンプレートを使用する",
    "deleteCustomT": "削除"
    },
    "es": {
    "customTemplate": "Plantilla personal",
    "customNoData": "No ha creado su plantilla personal. ",
    "customTocloud": "Aprenda a crear？",
    "useNow": "Usa esta plantilla",
    "deleteCustomT": "Borrar"
    },
    "it": {
    "customTemplate": "Modello Personale",
    "customNoData": "Non hai creato il tuo modello personale. ",
    "customTocloud": "Impara a creare？",
    "useNow": "Usa questo modello",
    "deleteCustomT": "Elimina"
    },
    "pt": {
    "customTemplate": "Modelo Pessoal",
    "customNoData": "Você não criou seu modelo pessoal. ",
    "customTocloud": "Aprenda como criar？",
    "useNow": "Usar este modelo",
    "deleteCustomT": "Eliminar"
    },
    "tw": {
    },
    "kr": {
    "customTemplate": "개인 템플릿",
    "customNoData": "아직 개인 템플릿을 만들지 않았네요~",
    "customTocloud": "제작 방법을 알아볼까요?",
    "useNow": "템플릿 적용하기",
    "deleteCustomT": "삭제하다"
    },
    "id": {
    "customTemplate": "Templat Pribadi",
    "customNoData": "Anda belum membuat templat pribadi.",
    "customTocloud": "Pelajari cara membuatnya?",
    "useNow": "Gunakan segera"
    }
}
</i18n>
